import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import ColorStore from 'stores/Model/ColorStore';
import { deserializeTimestamp, deserializeWithMappers, setFieldValues } from 'stores/Utils';



class ThemeStore {

  @setter @observable darkBgColor;
  @setter @observable darkBgBorderColor;
  @setter @observable btnBgColor;

  @setter @observable activeNavColor;
  @setter @observable iconColor;

  @setter @observable launcherPointsBgColor;
  @setter @observable launcherIconColor;

  static create(data={}) {
    const instance = new ThemeStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "darkBgColor": new ColorStore(),
      "darkBgBorderColor": new ColorStore(),
      "btnBgColor": new ColorStore(),

      "activeNavColor": new ColorStore(),
      "iconColor": new ColorStore(),

      "launcherPointsBgColor": new ColorStore(),
      "launcherIconColor": new ColorStore(),
    };
  }

  constructor(defaults=ThemeStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=ThemeStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "darkBgColor", "accessor": "dark_bg_color", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ColorStore},
      {"field": "darkBgBorderColor", "accessor": "dark_bg_border_color", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ColorStore},
      {"field": "btnBgColor", "accessor": "btn_bg_color", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ColorStore},

      {"field": "activeNavColor", "accessor": "active_nav_color", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ColorStore},
      {"field": "iconColor", "accessor": "icon_color", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ColorStore},

      {"field": "launcherPointsBgColor", "accessor": "launcher_points_bg_color", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ColorStore},
      {"field": "launcherIconColor", "accessor": "launcher_icon_color", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ColorStore},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get iconBgColorCss() {
    return `rgba(${this.iconColor.r}, ${this.iconColor.g}, ${this.iconColor.b}, 0.15)`;
  }
}

export default ThemeStore;



